import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import {
    fieldsWindowShapeDimension,
    fieldsWindowLeaf,
    fieldsWindowMaterial,
    fieldsWindowOpening,
    fieldsWindowGlazing,
    fieldsWindowInsulation,
} from './common/fieldsWindow';

const WindowsForm: IForm = {
    formId       : PublishedFormId.Windows,
    type         : FormTypeId.GlassAndMirror,
    thumbnailURL : '/resized-images/forms/windows.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.ShapeDimension,
        IFormFieldKey.Material,
        IFormFieldKey.WindowLeaf,
        IFormFieldKey.WindowOpening,
        IFormFieldKey.WindowGlazing,
        IFormFieldKey.WindowInsulation,
        IFormFieldKey.WindowInstallation,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        shapeDimension     : fieldsWindowShapeDimension,
        material           : fieldsWindowMaterial,
        windowLeaf         : fieldsWindowLeaf,
        windowOpening      : fieldsWindowOpening,
        windowGlazing      : fieldsWindowGlazing,
        windowInsulation   : fieldsWindowInsulation,
        windowInstallation : {
            value: undefined,
        },
        additionalData: additionalDataFactory({
            budgetMin          : 5000,
            budgetMax          : 15000,
            budgetDefaultValue : 9000,
            budgetStep         : 500,
        }),
        contact: fieldsContact,
    },
};

export default WindowsForm;
